if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.observerTarget = document.getElementById(this.dataset.observerId);
        this.productForm = document.getElementById(this.dataset.productForm);
        this.mainSubmit = document.getElementById(this.dataset.submitButton);
        this.button = this.querySelector('[data-sticky-atc-button]');

        this.onVariantChange = this.onVariantChange.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.syncButtonFromMain = this.syncButtonFromMain.bind(this);

        if (this.button) {
          this.button.addEventListener('click', this.onButtonClick);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }

        if (this.mainSubmit) {
          this.mainSubmitObserver = new MutationObserver(this.syncButtonFromMain);
          this.mainSubmitObserver.observe(this.mainSubmit, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            subtree: true,
            characterData: true,
            childList: true,
          });
        }

        this.setupObserver();
        this.syncButtonFromMain();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mainSubmitObserver?.disconnect();
        this.unsubscribeVariantChange?.();
        this.button?.removeEventListener('click', this.onButtonClick);
        document.body.classList.remove('lm-sticky-atc-active');
      }

      setupObserver() {
        if (!this.observerTarget || !('IntersectionObserver' in window)) return;

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const shouldShow = Boolean(entry && entry.boundingClientRect.bottom < 0);
            this.toggle(shouldShow);
          },
          { threshold: 0, rootMargin: '0px' }
        );

        this.intersectionObserver.observe(this.observerTarget);
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('hidden', !show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('lm-sticky-atc-active', show);
      }

      onButtonClick(event) {
        event.preventDefault();
        if (this.button?.disabled || this.button?.getAttribute('aria-disabled') === 'true') return;

        if (this.mainSubmit && !this.mainSubmit.disabled) {
          this.mainSubmit.click();
          return;
        }

        this.productForm?.requestSubmit?.() ||
          this.productForm?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      onVariantChange(event) {
        if (event?.data?.sectionId && event.data.sectionId !== this.dataset.section) return;
        this.syncButtonFromMain();
      }

      syncButtonFromMain() {
        if (!this.mainSubmit || !this.button) return;

        this.button.disabled = this.mainSubmit.disabled;

        if (this.mainSubmit.hasAttribute('aria-disabled')) {
          this.button.setAttribute('aria-disabled', this.mainSubmit.getAttribute('aria-disabled'));
        } else {
          this.button.removeAttribute('aria-disabled');
        }

        this.button.classList.toggle('loading', this.mainSubmit.classList.contains('loading'));

        const mainLabel = this.mainSubmit.querySelector('span:not(.loading__spinner):not(.svg-wrapper)');
        const stickyLabel = this.button.querySelector('[data-sticky-atc-button-label]');
        if (mainLabel && stickyLabel) {
          stickyLabel.textContent = mainLabel.textContent;
        }

        const mainSpinner = this.mainSubmit.querySelector('.loading__spinner');
        const stickySpinner = this.button.querySelector('.loading__spinner');
        if (mainSpinner && stickySpinner) {
          stickySpinner.classList.toggle('hidden', mainSpinner.classList.contains('hidden'));
        }
      }
    }
  );
}
